import { useReferralInvitesQuery } from '@/components/layouts/ReferralInviteLayout/hooks/useReferralInvitesQuery'

export function useReferralInvites() {
  return useReferralInvitesQuery().data
}
